import React from 'react';
import { Fab, Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useSelector, useDispatch } from 'react-redux';
import { setCartOpen } from '../../redux/slices/catalogCartSlice';

export const FloatingCartButton = ({ 
  color = '#49a35b',
  bottom = 80,
  right = 16 
}) => {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.catalogCart);
  const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);

  const handleCartClick = () => {
    dispatch(setCartOpen(true));
  };

  return (
    <Fab
      onClick={handleCartClick}
      sx={{
        position: 'fixed',
        bottom: bottom,
        right: right,
        backgroundColor: color,
        color: '#fff',
        width: 64,
        height: 64,
        display: { xs: 'flex', md: 'none' },
        boxShadow: '0 6px 20px rgba(73, 163, 91, 0.4)',
        backdropFilter: 'blur(10px)',
        '&:hover': {
          backgroundColor: '#3d8a4d',
          transform: 'scale(1.1)',
          boxShadow: '0 8px 24px rgba(73, 163, 91, 0.5)'
        },
        transition: 'all 0.3s ease-in-out',
        zIndex: 1000
      }}
    >
      <Badge 
        badgeContent={itemCount} 
        color="error"
        sx={{
          '& .MuiBadge-badge': {
            fontSize: '12px',
            fontWeight: 'bold',
            minWidth: '22px',
            height: '22px',
            borderRadius: '11px'
          }
        }}
      >
        <ShoppingCartIcon sx={{ fontSize: 32 }} />
      </Badge>
    </Fab>
  );
};
